import Page, { PageProps } from './Page';
import PageContents, { PageContentsProps } from './PageContents';

export default Page;
export { PageContents };
export type { PageProps, PageContentsProps };
